import script from "./Spinner.vue?vue&type=script&setup=true&lang=js"
export * from "./Spinner.vue?vue&type=script&setup=true&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=275096e9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275096e9"]])

export default __exports__